let localStorageAvailable = true;
let storage = {};

export default class LocalStorageWrapper {
    static getItem(key) {
        if (!localStorageAvailable) {
            return storage[key];
        }

        try {
            const retrievedObject = localStorage.getItem(key);
            return retrievedObject;
        } catch (error) {
            localStorageAvailable = false;
            return storage[key];
        }
    }

    static setItem(key, value) {
        if (!localStorageAvailable) {
            storage[key] = value;
            return;
        }

        try {
            localStorage.setItem(key, value);
        } catch (error) {
            localStorageAvailable = false;
            storage[key] = value;
        }
    }

    static clear() {
        if (!localStorageAvailable) {
            storage = {};
            return;
        }

        try {
            localStorage.clear();
        } catch (error) {
            localStorageAvailable = false;
            storage = {};
        }
    }
}
